// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"288":"544507cf00ba7249","700":"efd13ebd4a260fc2"}[chunkId] + ".js";
};